

import React from 'react'
import AccountCard from './AccountCard'

const Account = () => {

  const cardData = [
    { title: "Account Settings", content: "Jobseeker", buttonName: "Change account settings" },
    { title: "Email", content: "email123@gmail.com", buttonName: "Change email" },
    { title: "Password", content: "..........", buttonName: "Change password" },
    { title: "Phone number", content: "none", buttonName: "Add phone" },
    { title: "Third-party applications", content: "No third-party applications have access to your account", buttonName: null },
    { title: "", content: "email123@gmail.com", buttonName: "Sign out" },
  ]
  return (
    <div className='px-6 py-10'>
      <div className='border-b pb-10'>
        <h4>Account Settings</h4>
      </div>

      <div>
        {cardData.map((card, index) => (
          <AccountCard key={index} title={card.title} content={card.content} buttonName={card.buttonName} />
        ))}
      </div>

      <h5 className="mt-8 text-red-800">Close my account</h5>
    </div>
  )
}

export default Account
